import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { unidadesAlimentos } from 'src/app/models/alimento.model';
import { AlimentoPreparadoModel, categoriasPreparados } from 'src/app/models/alimento_preparado.model';
import { DocumentsService } from 'src/app/services/document.service';
import { UploadService } from 'src/app/services/upload.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-alimentos-preparados-d',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule,
    ImageCropperModule],
  templateUrl: './alimentos-preparados-d.component.html',
  styleUrl: './alimentos-preparados-d.component.css'
})
export class AlimentosPreparadosDComponent  implements OnInit {
  @Input({required: true}) userInfo: any;

  formAlimentoPreparado: FormGroup;
  submitFormAlimentoPreparado: boolean = false;
  listaAlimentosPreparados: any = [];
  categoriasPreparados: any = [] = categoriasPreparados;
  unidadesAlimentos: any = unidadesAlimentos;
  dataTablePreparados: any;
  editarAlimentoPreparado: any = false;
  pattern: string = 'preparado'
  env: any = environment

  filtroCategoria = '';
  filtroPropietario = 'todos'

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private utilsService: UtilsService,
              private uploadService: UploadService) {
    this.formAlimentoPreparado = this.fb.group
    ({
        nombre: ['', [Validators.required]],
        categoria: ['', [Validators.required]],
        marca: [''],
        porcion: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        unidad: ['', [Validators.required]],
        calorias:  ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        carbohidratos: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        azucar: ['', [Validators.pattern("^[0-9.]*$")]],
        fibra: ['', [Validators.pattern("^[0-9.]*$")]],
        proteinas: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaTotal: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaSaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaMonoinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaPoliinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaTrans: ['', [Validators.pattern("^[0-9.]*$")]],
        colesterol: ['', [Validators.pattern("^[0-9.]*$")]],
        informacion: [''],
    })
  }

  ngOnInit(): void {
    this.getPreparados();
  }

  @Output() messageEvent = new EventEmitter<string>();
  sendAlimentoPreparadoSelected(alimentoPreparado) {
    this.messageEvent.emit(alimentoPreparado);
  }
  getPreparados()
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtroCategoria != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtroCategoria
        }
      });
    }
    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    //debugger
    filtersQuery.push(
        {
          "bool": { should }
        }
    )

    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(this.env.businessId, this.pattern, query).subscribe({
        next: (data: any) => {
          console.log(data)
          if(this.dataTablePreparados) {
            this.dataTablePreparados.destroy();
            this.dataTablePreparados = null; // Eliminar la referencia
          }
          this.listaAlimentosPreparados = [];
          this.listaAlimentosPreparados = data;
          this.inicializarDataTablePreparados();
        },
        error: (error: any) => {
          console.error(error);
          this.inicializarDataTablePreparados();
        }
      });
    }, 1000);
  }
  inicializarDataTablePreparados()
  {
    if (this.dataTablePreparados) {
      this.dataTablePreparados.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTablePreparados = $('#dataTable-listaPreparados').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /*********** AGREGAR/EDITAR PREPARADO *************/
  modalAlimentoPreparado()
  {
    $('#modal-alimento-preparado').modal({backdrop: 'static', keyboard: false})
    $("#modal-alimento-preparado").modal('show');
  }
  modalEditarPreparado(preparado)
  {
    this.editarAlimentoPreparado = preparado;
    if(preparado.imagen) this.previewUrl = preparado.imagen.url

    this.formAlimentoPreparado.setValue({
      nombre: preparado.nombre,
      categoria: preparado.categoria,
      marca: preparado.marca,
      porcion: preparado.porcion,
      unidad: preparado.unidad,
      calorias:  preparado.calorias,
      carbohidratos: preparado.carbohidratos,
      azucar: preparado.azucar,
      fibra: preparado.azucar,
      proteinas: preparado.proteinas,
      grasaTotal: preparado.grasaTotal,
      grasaSaturada: preparado.grasaSaturada, 
      grasaMonoinsaturada: preparado.grasaMonoinsaturada,
      grasaPoliinsaturada: preparado.grasaPoliinsaturada,
      grasaTrans: preparado.grasaTrans,
      colesterol: preparado.colesterol,
      informacion: preparado.informacion,
    })
    this.enableOrDisableInputs(false);
    this.modalAlimentoPreparado();
  }

  createOrUpdatePreparadoFn() {
    this.submitFormAlimentoPreparado = true;
    if(this.formAlimentoPreparado.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    let preparadoDocModel: AlimentoPreparadoModel = {
      nombre: this.formAlimentoPreparado.get('nombre').value,
      categoria: this.formAlimentoPreparado.get('categoria').value,
      marca: this.formAlimentoPreparado.get('marca').value ? this.formAlimentoPreparado.get('marca').value : '',
      porcion: this.formAlimentoPreparado.get('porcion').value,
      unidad: this.formAlimentoPreparado.get('unidad').value,
      calorias: this.formAlimentoPreparado.get('calorias').value,
      carbohidratos: this.formAlimentoPreparado.get('carbohidratos').value,
      azucar: this.formAlimentoPreparado.get('azucar').value ? this.formAlimentoPreparado.get('azucar').value : null,
      fibra: this.formAlimentoPreparado.get('fibra').value ? this.formAlimentoPreparado.get('fibra').value : null,
      proteinas: this.formAlimentoPreparado.get('proteinas').value,
      grasaTotal: this.formAlimentoPreparado.get('grasaTotal').value,
      grasaSaturada: this.formAlimentoPreparado.get('grasaSaturada').value ? this.formAlimentoPreparado.get('grasaSaturada').value : null,
      grasaMonoinsaturada: this.formAlimentoPreparado.get('grasaMonoinsaturada').value ? this.formAlimentoPreparado.get('grasaMonoinsaturada').value : null,
      grasaPoliinsaturada: this.formAlimentoPreparado.get('grasaPoliinsaturada').value ? this.formAlimentoPreparado.get('grasaPoliinsaturada').value : null,
      grasaTrans: this.formAlimentoPreparado.get('grasaTrans').value ? this.formAlimentoPreparado.get('grasaTrans').value : null,
      colesterol: this.formAlimentoPreparado.get('colesterol').value ? this.formAlimentoPreparado.get('colesterol').value : null,
      // imagen: null,
      informacion: this.formAlimentoPreparado.get('informacion').value,
      propietario: this.userInfo.documentContainerId,
      activo: true,
      empresaId: this.userInfo.empresaId
    };

    // console.log("previewUrl", this.previewUrl)
    // console.log("rawFile", this.rawFile)
    let uuid = this.utilsService.create_UUID();
    if(this.croppedImage != null && this.rawFile != null) {
      let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '')
      this.uploadService.uploadImage(this.env.businessId, uuid, this.rawFile.name, croppedImage, this.rawFile.type).subscribe({
        next: (fileData: any) => {
          preparadoDocModel.imagen = { url: fileData.fileName, nombre: this.rawFile.name};

          if(this.editarAlimentoPreparado) this.updateAlimentoPreparadoFn(preparadoDocModel, this.editarAlimentoPreparado.documentId);
          if(!this.editarAlimentoPreparado) this.createAlimentoPreparadoFn(preparadoDocModel);
        },
        error: (error) => {
          console.error(error)
        }
      })
    }
    else {
      if(this.previewUrl == null) preparadoDocModel.imagen = null;
      if(this.editarAlimentoPreparado) this.updateAlimentoPreparadoFn(preparadoDocModel, this.editarAlimentoPreparado.documentId);
      if(!this.editarAlimentoPreparado) this.createAlimentoPreparadoFn(preparadoDocModel);
    }
  }
  createAlimentoPreparadoFn(preparadoDocModel: AlimentoPreparadoModel)
  {
    let businessId = this.env.businessId;
    let event: any = {}
    this.documentService.createDocumentInContainer(
        businessId,
        this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
        null,
        this.pattern,
        null,
        preparadoDocModel,
    ).subscribe({
      next: (data) => {
          // debugger
          console.log(data);
          this.submitFormAlimentoPreparado = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Preparado guardado con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-alimento-preparado").modal('hide');
          this.getPreparados();
          this.inicializarFormAlimentoPreparado();
        },
      error: (error) => {
        console.error(error);
      },
    });
  }
  updateAlimentoPreparadoFn(preparadoDocModel: AlimentoPreparadoModel, documentId) {
    let title = ''
    if(preparadoDocModel.activo) title = "Preparado actualizado con éxito";
    if(!preparadoDocModel.activo) title = "Preparado eliminado con éxito";
    
    this.documentService
      .updateDocumentInContainer(
        this.env.businessId,
        this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
        documentId,
        this.pattern,
        null,
        preparadoDocModel
      )
      .subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormAlimentoPreparado = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Preparado actualizado con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-alimento-preparado").modal('hide');
          this.getPreparados();
          this.inicializarFormAlimentoPreparado();
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  deleteAlimentoPreparadoFn(preparadoDocModel) {
    Swal.fire({
      title: 'Eliminar preparado',
      html: '¿Seguro que desea eliminar el preparado: <b>"'+preparadoDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        preparadoDocModel.activo = false;
        this.updateAlimentoPreparadoFn(preparadoDocModel, preparadoDocModel.documentId)
      }
    })
  }

  inicializarFormAlimentoPreparado()
  {
    this.editarAlimentoPreparado = false;
    this.errorFileType(false);
    this.enableOrDisableInputs(true);
    const inputElement = document.getElementById('imagenPreparado') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = ''; // Limpia el valor del input file
    }
    this.formAlimentoPreparado.setValue({
      nombre: '',
      categoria: '',
      marca: '',
      porcion: '',
      unidad: '',
      calorias:  '',
      carbohidratos: '',
      azucar: '',
      fibra: '',
      proteinas: '',
      grasaTotal: '',
      grasaSaturada: '', 
      grasaMonoinsaturada: '',
      grasaPoliinsaturada: '',
      grasaTrans: '',
      colesterol: '',
      informacion: '',
    })
  }
  enableOrDisableInputs(enable)
  {
    const controles = [
      'porcion',
      'unidad',
      'calorias',
      'carbohidratos',
      'azucar',
      'fibra',
      'proteinas',
      'grasaTotal',
      'grasaSaturada',
      'grasaMonoinsaturada',
      'grasaPoliinsaturada',
      'grasaTrans',
      'colesterol'
    ];
    controles.forEach(control => {
      const abstractControl = this.formAlimentoPreparado.get(control);
      if (abstractControl) {
        if(!enable) abstractControl.disable();
        if(enable) abstractControl.enable();
      }
    });
  }
  get formAlimentoPreparadoControl()
  {
      return this.formAlimentoPreparado.controls;
  }


  /**************** IMAGEN PREPARADO *****************/
  // Propiedades para Image Cropper
  imageChangedEvent: any = '';
  croppedImage: any = '';
  bolCroppedImg: boolean = false;
  // Información del archivo original
  selectedFile: File | null = null;
  rawFile: any;
  previewUrl: string | ArrayBuffer | null = null;
  fileChangeEvent(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];

      // Configurar el evento para el cropper
      this.imageChangedEvent = event;
      this.bolCroppedImg = true;

      // Almacenar detalles del archivo
      const reader = new FileReader();
      reader.onload = () => {
        this.rawFile = {
          file: reader.result,
          type: this.selectedFile?.type,
          name: this.selectedFile?.name
        };
        console.log('Raw File:', this.rawFile);
      };
      reader.readAsBinaryString(this.selectedFile);
    }
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64; // Imagen recortada en base64
    // console.log('Cropped Image:', this.croppedImage);
  }
  imageLoaded() {
    console.log('Image loaded');
  }
  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }
  loadImageFailed() {
    console.error('Failed to load image');
    this.errorFileType(true);
  }
  deleteImage() {
    this.errorFileType(false);
  }
  errorFileType(alert: boolean) {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    this.bolCroppedImg = false;
    this.selectedFile = null;
    this.previewUrl = null;
    this.rawFile = null;
    if (alert) {
      console.error('Invalid file type. Please select an image.');
    }
  }
}
